import { render, staticRenderFns } from "./ToolbarDesktop.vue?vue&type=template&id=2286dfda&scoped=true"
import script from "./ToolbarDesktop.vue?vue&type=script&lang=js"
export * from "./ToolbarDesktop.vue?vue&type=script&lang=js"
import style0 from "./ToolbarDesktop.vue?vue&type=style&index=0&id=2286dfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286dfda",
  null
  
)

export default component.exports